import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuth } from './useAuth'

interface Organization {
  id: string
  name: string
  slug: string
  branding: {
    logo_url?: string
    primary_color?: string
    secondary_color?: string
    company_name_display?: string
  } | null
}

interface OrganizationMembership {
  organization_id: string
  role: string
  is_current: boolean
  core_organizations: Organization
}

export function useUserOrganization() {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['user-organization', user?.id],
    queryFn: async () => {
      if (!user?.id) return null

      const { data, error } = await supabase
        .schema('core').from('organization_members')
        .select(`
          organization_id,
          role,
          is_current,
          core_organizations:organization_id (
            id,
            name,
            slug,
            branding
          )
        `)
        .eq('user_id', user.id)
        .eq('is_current', true)
        .eq('is_active', true)
        .single()

      if (error) {
        console.error('Error fetching organization:', error.message)
        return null
      }

      if (!data) {
        console.warn('User has no active organization membership')
        return null
      }

      return data as unknown as OrganizationMembership
    },
    enabled: !!user?.id,
  })
}
